"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _http_request = _interopRequireDefault(require("../../gateway/http_request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var CharactersCopyService = (applicationToken, sessionToken) => {
  var {
    buildHeader,
    get,
    post
  } = (0, _http_request.default)(applicationToken, sessionToken);
  var getCharactersRemaining = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (userId, uuid, totalCharBook) {
      var headers = {};
      var path = "/booknotes/api/v1/charactersremaining/user_id/".concat(userId, "/book_id/").concat(uuid, "/total_char_book/").concat(totalCharBook);
      headers = buildHeader(headers);
      var response = yield get(path, null, headers);
      return response;
    });
    return function getCharactersRemaining(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var getCharactersCopied = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (userId, uuid) {
      var headers = {};
      var path = "/booknotes/api/v1/characterscopied/user_id/".concat(userId, "/book_id/").concat(uuid);
      headers = buildHeader(headers);
      var response = yield get(path, null, headers);
      return response;
    });
    return function getCharactersCopied(_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
  var setCharactersCopied = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (userId, uuid, numCharsCopied, totalCharBook) {
      var headers = {};
      var path = '/booknotes/api/v1/characterscopy';
      headers = buildHeader(headers);
      var payload = {
        user_id: userId,
        book_id: uuid,
        total_char_copied: numCharsCopied,
        total_char_book: totalCharBook
      };
      var response = yield post(path, payload, headers);
      return response;
    });
    return function setCharactersCopied(_x6, _x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    getCharactersRemaining,
    getCharactersCopied,
    setCharactersCopied
  };
};
var _default = exports.default = CharactersCopyService;